export const actions = {
  BIBLIOTECAS_PREGUNTAS_LOAD_REQUESTED: 'BIBLIOTECAS_PREGUNTAS_LOAD_REQUESTED',
  BIBLIOTECAS_PREGUNTAS_LOAD_SUCCEEDED: 'BIBLIOTECAS_PREGUNTAS_LOAD_SUCCEEDED',
  BIBLIOTECAS_PREGUNTAS_LOAD_FAILED: 'BIBLIOTECAS_PREGUNTAS_LOAD_FAILED',

  BIBLIOTECAS_PREGUNTAS_FILTERED_LOAD_REQUESTED: 'BIBLIOTECAS_PREGUNTAS_FILTERED_LOAD_REQUESTED',
  BIBLIOTECAS_PREGUNTAS_FILTERED_LOAD_SUCCEEDED: 'BIBLIOTECAS_PREGUNTAS_FILTERED_LOAD_SUCCEEDED',
  BIBLIOTECAS_PREGUNTAS_FILTERED_LOAD_FAILED: 'BIBLIOTECAS_PREGUNTAS_FILTERED_LOAD_FAILED',

  BIBLIOTECA_PREGUNTA_DELETE_REQUESTED: 'BIBLIOTECA_PREGUNTA_DELETE_REQUESTED',
  BIBLIOTECA_PREGUNTA_DELETE_SUCCEEDED: 'BIBLIOTECA_PREGUNTA_DELETE_SUCCEEDED',
  BIBLIOTECA_PREGUNTA_DELETE_FAILED: 'BIBLIOTECA_PREGUNTA_DELETE_FAILED',

  BIBLIOTECA_PREGUNTA_CREATE_REQUESTED: 'BIBLIOTECA_PREGUNTA_CREATE_REQUESTED',
  BIBLIOTECA_PREGUNTA_CREATE_SUCCEEDED: 'BIBLIOTECA_PREGUNTA_CREATE_SUCCEEDED',
  BIBLIOTECA_PREGUNTA_CREATE_FAILED: 'BIBLIOTECA_PREGUNTA_CREATE_FAILED',

  BIBLIOTECA_PREGUNTA_UPDATE_REQUESTED: 'BIBLIOTECA_PREGUNTA_UPDATE_REQUESTED',
  BIBLIOTECA_PREGUNTA_UPDATE_SUCCEEDED: 'BIBLIOTECA_PREGUNTA_UPDATE_SUCCEEDED',
  BIBLIOTECA_PREGUNTA_UPDATE_FAILED: 'BIBLIOTECA_PREGUNTA_UPDATE_FAILED',

  BIBLIOTECA_PREGUNTA_LOAD_BY_ID_REQUESTED: 'BIBLIOTECA_PREGUNTA_LOAD_BY_ID_REQUESTED',
  BIBLIOTECA_PREGUNTA_LOAD_BY_ID_SUCCEEDED: 'BIBLIOTECA_PREGUNTA_LOAD_BY_ID_SUCCEEDED',
  BIBLIOTECA_PREGUNTA_LOAD_BY_ID_FAILED: 'BIBLIOTECA_PREGUNTA_LOAD_BY_ID_FAILED',

  PREGUNTA_BIBLIOTECA_DELETED_STATE_CHANGED: 'PREGUNTA_BIBLIOTECA_DELETED_STATE_CHANGED',
  PREGUNTA_BIBLIOTECA_EDITED: 'PREGUNTA_BIBLIOTECA_EDITED',
  PREGUNTA_BIBLIOTECA_CREATED: 'PREGUNTA_BIBLIOTECA_CREATED',
  OPCION_PREGUNTA_EDITED: 'OPCION_PREGUNTA_EDITED',
  OPCION_PREGUNTA_CREATED: 'OPCION_PREGUNTA_CREATED',

  ASIGNAR_OPCIONES_PREGUNTA: 'ASIGNAR_OPCIONES_PREGUNTA',

  BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID_REQUESTED: 'BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID_REQUESTED',
  BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID_SUCCEEDED: 'BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID_SUCCEEDED',
  BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID_FAILED: 'BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID_FAILED',

  BIBLIOTECA_PREGUNTA_PRODUCTO_UPDATE_REQUESTED: 'BIBLIOTECA_PREGUNTA_PRODUCTO_UPDATE_REQUESTED',
  BIBLIOTECA_PREGUNTA_PRODUCTO_UPDATE_SUCCEEDED: 'BIBLIOTECA_PREGUNTA_PRODUCTO_UPDATE_SUCCEEDED',
  BIBLIOTECA_PREGUNTA_PRODUCTO_UPDATE_FAILED: 'BIBLIOTECA_PREGUNTA_PRODUCTO_UPDATE_FAILED',

  BIBLIOTECA_PREGUNTA_SET_PIJAMA_SUCCEEDED: 'BIBLIOTECA_PREGUNTA_SET_PIJAMA_SUCCEEDED',
  BIBLIOTECA_PREGUNTA_SET_REPETIRBYQUANTITY_SUCCEEDED:
    'BIBLIOTECA_PREGUNTA_SET_REPETIRBYQUANTITY_SUCCEEDED',
}

export const getBibPreguntasAction = dispatch => {
  dispatch({
    type: actions.BIBLIOTECAS_PREGUNTAS_LOAD_REQUESTED,
  })
}

export const getBibPreguntasFilteredAction = (dispatch, filter) => {
  dispatch({
    type: actions.BIBLIOTECAS_PREGUNTAS_FILTERED_LOAD_REQUESTED,
    payload: filter,
  })
}

export const deleteBibPreguntaAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBLIOTECA_PREGUNTA_DELETE_REQUESTED,
    payload: id,
  })
}

export const insertBibPreguntaAction = (dispatch, bibPregunta) => {
  dispatch({
    type: actions.BIBLIOTECA_PREGUNTA_CREATE_REQUESTED,
    payload: bibPregunta,
  })
}

export const insertedBibPreguntaAction = (dispatch, bibPregunta) => {
  dispatch({
    type: actions.BIBLIOTECA_PREGUNTA_CREATE_SUCCEEDED,
    payload: bibPregunta,
  })
}

export const updateBibPreguntaAction = (dispatch, bibPregunta) => {
  dispatch({
    type: actions.BIBLIOTECA_PREGUNTA_UPDATE_REQUESTED,
    payload: bibPregunta,
  })
}

export const getBibPreguntaByIdAction = (dispatch, id) => {
  dispatch({
    type: actions.BIBLIOTECA_PREGUNTA_LOAD_BY_ID_REQUESTED,
    payload: id,
  })
}

export const preguntaBibliotecaDeletedStateChangedAction = (dispatch, payload) => {
  dispatch({
    type: actions.PREGUNTA_BIBLIOTECA_DELETED_STATE_CHANGED,
    payload,
  })
}

export const preguntaBibliotecaEditedAction = (dispatch, payload) => {
  dispatch({
    type: actions.PREGUNTA_BIBLIOTECA_EDITED,
    payload,
  })
}

export const preguntaBibliotecaCreatedAction = (dispatch, payload) => {
  dispatch({
    type: actions.PREGUNTA_BIBLIOTECA_CREATED,
    payload,
  })
}

export const opcionPreguntaEditedAction = (dispatch, payload) => {
  dispatch({
    type: actions.OPCION_PREGUNTA_EDITED,
    payload,
  })
}

export const opcionPreguntaCreatedAction = (dispatch, payload) => {
  dispatch({
    type: actions.OPCION_PREGUNTA_CREATED,
    payload,
  })
}

export const asignarOpcionesPreguntaAction = (dispatch, payload) => {
  dispatch({
    type: actions.ASIGNAR_OPCIONES_PREGUNTA,
    payload,
  })
}

export const bibliotecaPreguntaCreatedAction = (dispatch, payload) => {
  dispatch({
    type: actions.BIBLIOTECA_PREGUNTA_CREATE_SUCCEEDED,
    payload,
  })
}

export const getBibliotecaPreguntaByProductoIdAction = (dispatch, payload) => {
  dispatch({
    type: actions.BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID_REQUESTED,
    payload,
  })
}

export const updateBibPreguntasProductoAction = (dispatch, payload) => {
  dispatch({
    type: actions.BIBLIOTECA_PREGUNTA_PRODUCTO_UPDATE_REQUESTED,
    payload,
  })
}

export const setEsPijamaAction = (dispatch, payload) => {
  dispatch({
    type: actions.BIBLIOTECA_PREGUNTA_SET_PIJAMA_SUCCEEDED,
    payload,
  })
}

export const setRepetirByQuantityAction = (dispatch, payload) => {
  dispatch({
    type: actions.BIBLIOTECA_PREGUNTA_SET_REPETIRBYQUANTITY_SUCCEEDED,
    payload,
  })
}
